import { render } from "./FrequentlyAskedQuestions.vue?vue&type=template&id=493194fc&scoped=true"
import script from "./FrequentlyAskedQuestions.vue?vue&type=script&lang=js"
export * from "./FrequentlyAskedQuestions.vue?vue&type=script&lang=js"

import "./FrequentlyAskedQuestions.vue?vue&type=style&index=0&id=493194fc&lang=css&scoped=true"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493194fc"]])

export default __exports__